import getConfig from "next/config";

const {
  publicRuntimeConfig: { basePath },
} = getConfig();

export const imageBasePath = basePath;
